//-----------------------------
// save current campaign notes
//-----------------------------
export default function saveCurrentCampaignNotes(campaign_notes) {
  // -------------------------------
  // check got campaign notes array
  // -------------------------------
  if (!Array.isArray(campaign_notes)) return null
  //-----------------------------------------------------------------------------
  // create array with specified props (editable or keys) for each campaign note
  //-----------------------------------------------------------------------------
  const original_campaign_notes = campaign_notes.map((note) => ({
    name: 'note',
    id: note?.id ?? null, // character campaign note id if existing (should be there)
    value: note.note,
  }))
  return original_campaign_notes
}